import React from 'react';
import { Loader2, AlertCircle, ArrowRight, Flame } from 'lucide-react';
import { useSquareServices } from '../../hooks/useBookingData';

const fromPrice = (variations) => {
  const min = Math.min(...variations.map((v) => v.price_cents));
  return `$${(min / 100).toFixed(2)}`;
};

export const StepService = ({ onSelect }) => {
  const { services, popularName, loading, loadError } = useSquareServices();

  if (loading) {
    return (
      <div className="py-12 flex items-center justify-center text-neutral-600">
        <Loader2 className="w-5 h-5 animate-spin mr-2" /> Loading services…
      </div>
    );
  }
  if (loadError) {
    return (
      <div className="py-8 text-center" data-testid="booking-services-error">
        <AlertCircle className="w-10 h-10 text-red-600 mx-auto mb-3" />
        <p className="text-neutral-700">{loadError}</p>
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="step-service">
      <p className="text-neutral-600 text-sm">Choose the service you&apos;d like to book:</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {services.map((s) => (
          <button
            key={s.name}
            type="button"
            onClick={() => onSelect(s.name)}
            data-testid={`pick-service-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
            className={`group relative text-left p-4 rounded-sm border-2 bg-white hover:border-red-600 transition-colors flex items-center justify-between gap-3 ${
              s.name === popularName ? 'border-red-600 shadow-md shadow-red-600/10' : 'border-neutral-200'
            }`}
          >
            {s.name === popularName && (
              <span
                className="absolute -top-2.5 right-3 inline-flex items-center gap-1 bg-red-600 text-white font-display uppercase tracking-widest text-[11px] font-bold px-2 py-0.5 rounded-sm"
                data-testid="most-popular-tag"
              >
                <Flame className="w-3 h-3" /> Most Popular
              </span>
            )}
            <div>
              <div className="font-display uppercase font-bold text-neutral-950 text-lg leading-tight">{s.name}</div>
              <div className="text-neutral-500 text-sm">
                {s.variations.length > 1 ? 'From ' : ''}{fromPrice(s.variations)}
              </div>
            </div>
            <ArrowRight className="w-4 h-4 text-red-600 shrink-0 group-hover:translate-x-1 transition-transform" />
          </button>
        ))}
      </div>
    </div>
  );
};
